/**
 * Default entity ATIs for Jira (1P).
 */
import type { JiraEntityATI } from '@atlassian/search-client/common/types';

export type ReadonlyJiraEntityATI = readonly JiraEntityATI[];

export const DEFAULT_JIRA_ENTITY_ATI: ReadonlyJiraEntityATI = [
	'ati:cloud:jira:project',
	'ati:cloud:jira:issue',
	'ati:cloud:jira:filter',
	'ati:cloud:jira:dashboard',
	'ati:cloud:jira:board',
	'ati:cloud:jira:plan',
];
